<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Add / Edit Training Record
							</div>
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">
										Please enter the title and description for this training overview.
									</div>
								</div>
								<div class="training-overview-page">
									<el-form ref="formRef"
										:model="form"
										:rules="rules"
										label-position="top"
										class="training-form">
										<el-form-item label="Title"
											prop="title"
											required>
											<el-input v-model="form.title"
												placeholder=""
												clearable />
										</el-form-item>
										<el-form-item label="Description"
											prop="description"
											required>
											<el-input v-model="form.description"
												type="textarea"
												:rows="4"
												resize="none"
												placeholder="" />
										</el-form-item>
										<div class="requirement-card">
											<div class="requirement-card__header">
												<div class="requirement-card__title">
													Training Requirements
												</div>
											</div>
											<div class="requirement-card__body">
												<el-table ref="tableRef"
													:data="tableData"
													border
													class="table_el"
													header-cell-class-name="table-header"
													empty-text="No training requirements found">
													<el-table-column prop="id"
														label="Actions"
														width="80"
														align="center">
														<template #default="scope">
															<div class="inline_btn">
																<el-button type="primary"
																	size="mini"
																	@click="handleClick('Edit',scope.row)">
																	Edit
																</el-button>
															</div>
														</template>
													</el-table-column>
													<el-table-column prop="item_name"
														label="Item ID"
														sortable
														min-width="180" />
													<el-table-column prop="leixing_name"
														label="Training Item Type"
														sortable
														min-width="260" />
													<el-table-column prop="is_certification_name"
														label="Is Certification Required?"
														sortable
														min-width="180">
													</el-table-column>
													<el-table-column prop="id"
														label="Actions"
														width="100"
														align="center">
														<template #default="scope">
															<div class="inline_btn">
																<el-button type="danger"
																	size="mini"
																	@click="handleClick('Delete',scope.row)">
																	Delete
																</el-button>
															</div>
														</template>
													</el-table-column>
												</el-table>
												<div class="table-actions">
													<el-button type="primary"
														@click="handleAddGeneral">
														Add General Training Item
													</el-button>
													<el-button type="primary"
														@click="handleAddDocument">
														Add Document Training Item
													</el-button>
												</div>
											</div>
										</div>
										<div class="footer-actions">
											<el-button type="primary"
												@click="handleSave">
												Save
											</el-button>
											<el-button type="primary"
												@click="handleCancel">
												Cancel
											</el-button>
										</div>
									</el-form>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--编辑培训要求-->
		<el-dialog :title="resetName" :visible.sync="dialogVisible" width="30%">
			<div class="reset_box">
				<div class="form_box">
					<div class="tips_el">
						<div class="tips">
							Please specify whether this training requires certification.
						</div>
					</div>
					<el-form :model="ruleForm" :rules="rules2" ref="ruleForm">
						<div class="input_el">
							<el-form-item label="Is Certification Required?"
								prop="is_certification"
								required>
								<el-select v-model="ruleForm.is_certification"
									placeholder="Please select"
									clearable
									style="width: 100%;">
									<el-option label="Yes" :value="1"></el-option>
									<el-option label="No" :value="2"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el"
						type="default"
						round
						@click="dialogVisible = false">
						Cancel
					</van-button>
					<van-button class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Save
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--编辑培训要求-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>
<script>
import {
	trainRecordAdd,
	trainRecordEdit,
	trainRecordDetail,
	trainRecordRequirementsEdit,
	trainRecordRequirementsDel
} from '@/api/trainManage/configTrain/trainRecord/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export
default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			tableLoading: false,
			form: {
				title: "",
				description: "",
			},
			rules: {
				title: [{ required: true, message: "Please enter", trigger: "blur" }],
				description: [{ required: true, message: "Please enter", trigger: "blur" }],
			},
			tableData: [],
			oid: null,
			dialogVisible: false,
			resetId: null,
			resetName: '',
			ruleForm: {
				is_certification: ''
			},
			rules2: {
				is_certification: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
			}
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		that.oid = that.$route.query.oid;
		if(that.oid) {
			//编辑
			trainRecordDetail({ id: that.oid }).then(res => {
				if(res.code == 200) {
					that.form.id = res.data.id;
					that.form.title = res.data.title;
					that.form.description = res.data.description;
					that.tableData = res.data.requirements_list;
				}
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
		}
	},
	methods: {
		handleAddGeneral() {
			let that = this;
			if(!that.oid) {
				that.$refs.formRef.validate((valid) => {
					if (!valid) return;
					that.$toast.loading({ duration: 0, forbidClick: true });
					// 添加
					trainRecordAdd(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.oid = res.data;
							that.$router.push({ path: '/TrainControl/general-index', query: { recordId: that.oid, recordName: encodeURIComponent(that.form.title) } });
						}
					});
				});
			}else {
				that.$router.push({ path: '/TrainControl/general-index', query: { recordId: that.oid, recordName: encodeURIComponent(that.form.title) } });
			}
		},
		handleAddDocument() {
			let that = this;
			if(!that.oid) {
				that.$refs.formRef.validate((valid) => {
					if (!valid) return;
					that.$toast.loading({ duration: 0, forbidClick: true });
					// 添加
					trainRecordAdd(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.oid = res.data.id;
							that.$router.push({ path: '/DocControl/documentsSearch', query: { recordId: that.oid, recordName: encodeURIComponent(that.form.title) } });
						}
					});
				});
			}else {
				that.$router.push({ path: '/DocControl/documentsSearch', query: { recordId: that.oid, recordName: encodeURIComponent(that.form.title) } });
			}
		},
		handleSave() {
			let that = this;
			that.$refs.formRef.validate((valid) => {
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				if(that.oid) {
					// 编辑
					trainRecordEdit(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.push({ path: 'record-search' });
							}, 800);
						}
					});
				}else {
					// 添加
					trainRecordAdd(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.push({ path: 'record-search' });
							}, 800);
						}
					});
				}
			});
		},
		handleCancel() {
			this.$router.push({ path: 'record-search' });
		},
		handleClick(title, value) {
			let that = this;
			switch (title) {
			case "Edit":
				that.resetId = value.id;
				that.resetName = 'Edit - ' + value.item_name;
				that.ruleForm.is_certification = Number(value.is_certification);
				that.dialogVisible = true;
				break;
			case "Delete":
				that.$confirm('Delete this item?', 'Confirmation', {
					type: 'warning'
				}).then(() => {
					that.$toast.loading({ duration: 0, forbidClick: true });
					trainRecordRequirementsDel({ id: value.id }).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				}).catch(() => {
					// that.$message({ type: 'info', message: '您已取消退出登录' });
				});
				break;
			}
		},
		//编辑档案信息(认证状态)
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.resetId) {
						that.$toast.loading({ duration: 0, forbidClick: true });
						trainRecordRequirementsEdit({
							id: that.resetId,
							is_certification: that.ruleForm.is_certification
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}
						});
					}
				}else {
					return false;
				}
			});
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
}
</script>

<style lang="less" scoped>
//编辑培训要求
.reset_box{
	.btn_box{
		padding-top: 30px;
		text-align: right;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
	.tips_el{
		margin: 10px 0 20px 0;
		border-radius: 6px;
		background-color: #ffb1001a;
		padding: 10px 8px;
		.tips{
			padding: 2px 0;
			font-size: 16px;
			font-weight: bold;
		}
	}
	.form_box{
		.input_el{
			.tit{
				padding-bottom: 5px;
				font-size: 14px;
				color: #333333;
			}
			.required::before {
				content: '*';
				color: red;
				margin-right: 2px;
			}
		}
	}
}
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-overview-page {
  padding: 16px;
  min-height: 100%;
  box-sizing: border-box;
}

.training-form {
  width: 100%;
}

.page-tip {
  background: #f7f1e7;
  color: #333;
  border-radius: 4px;
  padding: 14px 16px;
  margin-bottom: 20px;
  font-size: 15px;
}

.requirement-card {
  margin-top: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  overflow: hidden;
}

.requirement-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f7fa;
  padding: 10px 12px;
  border-bottom: 1px solid #dcdfe6;
}

.requirement-card__title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
}

.requirement-card__body {
  padding: 0;
  background: #fff;
}

.table-actions {
  padding: 16px 0 6px 10px;
}

.error-text {
  color: #f56c6c;
  font-size: 14px;
  font-weight: 500;
}

.table-error {
  margin-top: 14px;
}

.page-error {
  text-align: center;
  margin-top: 28px;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 50px;
  padding-bottom: 16px;
}

/* 让表单标题更接近截图样式 */
::v-deep .el-form-item__label {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 8px;
}

/* 必填星号颜色 */
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  color: #f56c6c;
}

/* 输入框高度和边框风格微调 */
::v-deep .el-input__inner {
  height: 44px;
  line-height: 44px;
}

::v-deep .el-textarea__inner {
  min-height: 110px !important;
}

/* 表格空状态更像截图 */
::v-deep .el-table__empty-block {
  min-height: 80px;
}

::v-deep .el-table__empty-text {
  color: #606266;
  font-size: 16px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

